import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const UsbIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "UsbGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M22.6299 11.9986C22.6302 12.0428 22.6173 12.0864 22.5926 12.1243C22.5678 12.1623 22.5322 12.1933 22.4896 12.2139L19.7117 13.7496C19.6701 13.7741 19.6221 13.7878 19.5727 13.7893C19.5233 13.7908 19.4744 13.7801 19.4311 13.7583C19.3884 13.7356 19.353 13.7029 19.3284 13.6636C19.3037 13.6243 19.2908 13.5797 19.2908 13.5343V12.5124H11.8489C12.6377 13.6492 13.1116 15.5811 14.0188 15.5811H14.8512V14.8118C14.8508 14.7781 14.8577 14.7447 14.8715 14.7135C14.8853 14.6824 14.9057 14.6541 14.9316 14.6303C14.9574 14.6065 14.9882 14.5877 15.022 14.5749C15.0559 14.5622 15.0922 14.5559 15.1287 14.5563H17.9066C17.9431 14.5559 17.9794 14.5622 18.0132 14.5749C18.0471 14.5877 18.0779 14.6065 18.1037 14.6303C18.1296 14.6541 18.15 14.6824 18.1638 14.7135C18.1776 14.7447 18.1845 14.7781 18.184 14.8118V17.3695C18.1845 17.4032 18.1776 17.4366 18.1638 17.4677C18.15 17.4989 18.1296 17.5272 18.1037 17.551C18.0779 17.5748 18.0471 17.5936 18.0132 17.6063C17.9794 17.619 17.9431 17.6254 17.9066 17.625H15.1287C15.0922 17.6254 15.0559 17.619 15.022 17.6063C14.9882 17.5936 14.9574 17.5748 14.9316 17.551C14.9057 17.5272 14.8853 17.4989 14.8715 17.4677C14.8577 17.4366 14.8508 17.4032 14.8512 17.3695V16.603H14.0188C11.6681 16.603 11.4904 12.5124 10.131 12.5124H7.004C6.75147 13.3908 5.88475 14.0482 4.8528 14.0482C3.62754 14.0453 2.62988 13.1267 2.62988 11.9986C2.62988 10.8704 3.62754 9.9518 4.8528 9.9518C5.88475 9.9518 6.75459 10.6063 7.004 11.4876C8.22302 11.4876 8.37267 11.7603 9.3298 9.75373C10.58 7.196 11.1412 7.39695 12.725 7.39695C12.8566 7.0557 13.1149 6.76825 13.4543 6.58534C13.7937 6.40242 14.1924 6.33582 14.5799 6.39729C14.9675 6.45876 15.319 6.64435 15.5724 6.92128C15.8258 7.19821 15.9648 7.54868 15.9648 7.91079C15.9648 8.2729 15.8258 8.62336 15.5724 8.90029C15.319 9.17723 14.9675 9.36281 14.5799 9.42428C14.1924 9.48575 13.7937 9.41915 13.4543 9.23624C13.1149 9.05333 12.8566 8.76587 12.725 8.42463H11.7959C10.8886 8.42463 10.4148 10.3594 9.62598 11.4933H19.2939V10.4714C19.2939 10.3767 19.3469 10.2963 19.4342 10.2475C19.5215 10.1987 19.6338 10.2073 19.7117 10.2561L22.4896 11.7919C22.5769 11.8235 22.6299 11.9096 22.6299 11.9986Z"
        fill="#696969"
      />
    </svg>
  );
};

export default UsbIcon;
